<template>
  <div v-for="(economicIndicator, index) in application.economicIndicators" :key="index"
       class="my-4">
    <h4 class="tab__content__title mb-2">{{ $lang.app.MAIN_TECHNO_ECONOMIC_INDICATORS_OF_OBJECT }}</h4>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.DENOMINATION }}</span>
      <span class="stack__value">{{ economicIndicator.name }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.UNIT_OF_MEASUREMENT }}</span>
      <span class="stack__value">{{ unitOfMeasurements.find(item => item.value === economicIndicator.unitOfMeasurement)?.label }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.VALUE }}</span>
      <span class="stack__value">{{ economicIndicator.value }}</span>
    </div>
  </div>
</template>
<script>
import unitOfMeasurementApi from "../../../api/ref/unitOfMeasurement";

export default {
  props: {
    application: Object
  },
  data() {
    return {
      unitOfMeasurements: []
    }
  },
  created() {
    this.initUnitOfMeasurement()
  },
  methods: {
    initUnitOfMeasurement() {
      unitOfMeasurementApi.getUnitOfMeasurements()
          .then(res => {
            this.unitOfMeasurements = res.map(item => ({
              value: item.id,
              label: item.name
            }))
          })
    }
  }
}
</script>